import { AxiosResponse } from 'axios'
import axios from '@/services/axios'

export default abstract class SuppliersApi {
  public static entity = 'suppliers'
  public static baseRoute = `${process.env.VUE_APP_SHOP_V2_BASE_URI}`

  public static async list(
    arenaId: string,
    params: string,
  ): Promise<AxiosResponse> {
    return await axios.get(
      `${this.baseRoute}/arenas/${arenaId}/${this.entity}?${params}`,
    )
  }

  public static async create(
    arenaId: string,
    data: object,
  ): Promise<AxiosResponse> {
    return await axios.post(
      `${this.baseRoute}/arenas/${arenaId}/${this.entity}`,
      data,
    )
  }

  public static async get(arenaId: string, id: string): Promise<AxiosResponse> {
    return await axios.get(
      `${this.baseRoute}/arenas/${arenaId}/${this.entity}/${id}`,
    )
  }

  public static async update(
    arenaId: string,
    id: string,
    data: object,
  ): Promise<AxiosResponse> {
    return await axios.patch(
      `${this.baseRoute}/arenas/${arenaId}/${this.entity}/${id}`,
      data,
    )
  }

  public static async delete(
    arenaId: string,
    id: string,
  ): Promise<AxiosResponse> {
    return await axios.delete(
      `${this.baseRoute}/arenas/${arenaId}/${this.entity}/${id}`,
    )
  }
}
